import { ButtonVariant } from '../button/types'

export const SpinnerVariant = ButtonVariant
export type SpinnerVariant = ButtonVariant

export const SpinnerSize = {
  Small: 'small',
  Medium: 'medium',
  Large: 'large',
} as const

export type SpinnerSize = (typeof SpinnerSize)[keyof typeof SpinnerSize]

export interface SpinnerProps {
  variant?: SpinnerVariant
  size?: SpinnerSize
  className?: string
}
